angular
	.module 'App.Module.Report', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY) ->
		$stateProvider
			.state 'reports',
				abstract: true
				url: '/reports',
				views:
					main:
						controller: 'MainCrudController'
						controllerAs: 'mainCrud'

			.state 'reports.orders',
				url: '/orders?order_id&sort_by&tender_type_id&shop_id&start_date&end_date&customer_id&transaction_type',
				views:
					'main@':
						controller: 'OrderController'
						controllerAs: 'vm'
						templateUrl: '@app/report/order/order.view.html'
				data:
					restrict: 'Backoffice.TopMenu.Report.Orders'
			.state 'reports.turnover',
				url: '/turnover',
				views:
					"main@":
						controller: 'TurnoverController'
						controllerAs: 'vm'
						templateUrl: '@app/report/turnover/turnover.view.html'
				data:
					restrict: "Backoffice.TopMenu.Report.Turnover"

			.state 'reports.eod',
				url: '/day_tallies',
				views:
					"main@":
						controller: 'DayTallyController'
						controllerAs: 'vm'
						templateUrl: '@app/report/day-tally/day-tally.view.html'
				data:
					restrict: "Backoffice.TopMenu.Report.Eod"

			.state 'reports.sales',
				url: '/sales',
				views:
					"main@":
						controller: 'SalesController'
						controllerAs: 'vm'
						templateUrl: '@app/report/sales/sales.view.html'
				data:
					restrict: "Backoffice.TopMenu.Report.SalesReport"

			.state 'reports.tendertypes',
				url: '/tendertypes',
				views:
					"main@":
						controller: 'TenderTypeReportController'
						controllerAs: 'vm'
						templateUrl: '@app/report/tender-type/tender-type.view.html'
				data:
					restrict: "Backoffice.TopMenu.TenderTypes"
			.state 'reports.invoices',
				url: '/reports/invoices',
				views:
					'main@':
						controller: 'InvoiceController'
						controllerAs: 'vm'
						templateUrl: '@app/report/invoice/invoice.view.html'
				data:
					restrict: 'Shared.Payment.InvoiceType.Enabled'
			.state 'reports.invoiced_orders',
				url: '/reports/invoiced_orders?invoice_id',
				views:
					'main@':
						controller: 'InvoicedOrderController'
						controllerAs: 'vm'
						templateUrl: '@app/report/invoiced-order/invoiced-order.view.html'
				data:
					restrict: 'Shared.Payment.InvoiceType.Enabled'
			.state 'reports.giftcards',
				url: '/giftcards',
				views:
					"main@":
						controller: 'GiftcardController'
						controllerAs: 'vm'
						templateUrl: '@app/report/giftcard/giftcard.view.html'
				data:
					restrict: 'Backoffice.TopMenu.Report.Giftcards'

			.state 'reports.purchase_orders',
				url: '/purchase_orders',
				views:
					"main@":
						controller: 'PurchaseOrderReportController'
						controllerAs: 'vm'
						templateUrl: '@app/report/purchase-order/purchase-order.view.html'
				data:
					restrict: [
						'AND',
						'Backoffice.TopMenu.Stock',
						'Backoffice.TopMenu.Report.PurchaseOrderSuggestion.Enabled'
					]
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					suppliers: (SuppliersRepository) ->
						return SuppliersRepository.getEntities()
					shops: (ShopRepository) ->
						query = ShopRepository.createQuery()
						query.withoutAnyRelations()

						return ShopRepository.getEntities(query)
					stockLocations: (StockLocationRepository) ->
						query = StockLocationRepository.createQuery()
						query.withoutAnyRelations()

						return StockLocationRepository.getEntities(query)

			.state 'reports.counting_degree',
				url: '/counting_degree'
				views:
					'main@':
						controller: 'CountingDegreeController'
						controllerAs: 'vm'
						templateUrl: '@app/report/counting-degree/counting-degree.view.html'
				data:
					restrict: 'Backoffice.TopMenu.Report.StockReports'
				resolve:
					priceRegions: (PriceRegionRepository) ->
						return PriceRegionRepository.getEntities()

			.state 'reports.my_reports',
				url: '/my_reports?report_type'
				views:
					'main@':
						controller: 'MyReportController'
						controllerAs: 'vm'
						templateUrl: '@app/report/my-report/my-report.view.html'
				data:
					restrict: 'Backoffice.TopMenu.Report.MyReport.Enabled'

			.state 'reports.saft',
				url: '/saf-t'
				views:
					'main@':
						controller: 'SaftController'
						controllerAs: 'vm'
						templateUrl: '@app/report/saft/saft.view.html'
				data:
					restrict: ['OR', 'Shared.Setting.SaftNoCrReport.Enabled', 'Shared.Setting.SaftPtReport.Enabled']
				resolve:
					shops: (ShopRepository) ->
						return ShopRepository.getEntities()
					registers: (RegisterRepository) ->
						return RegisterRepository.getEntities()

			.state 'reports.cashier_performance',
				url: '/cashier_performance'
				views:
					'main@':
						controller: 'CashierPerformanceController'
						controllerAs: 'vm'
						templateUrl: '@app/report/cashier-performance/cashier-performance.view.html'
				data:
					restrict: 'Backoffice.TopMenu.Report.CashierPerformance.Enabled'

			.state 'reports.cash_movement_events',
				url: '/cash_movement_events'
				views:
					'main@':
						controller: 'CashMovementEventController'
						controllerAs: 'vm'
						templateUrl: '@app/report/cash-movement-event/cash-movement-event.view.html'
				data:
					restrict: 'Backoffice.TopMenu.Report.CashMovementEvent.Enabled'

			.state 'reports.product_price_history',
				url: '/product_price_history'
				views:
					'main@':
						controller: 'ProductPriceHistoryController'
						controllerAs: 'vm'
						templateUrl: '@app/report/product-price-history/product-price-history.view.html'
				data:
					restrict: 'Backoffice.TopMenu.Report.ProductPriceHistory.Enabled'

			.state 'reports.fiskaly',
				url: '/fiskaly'
				views:
					'main@':
						controller: 'FiskalyReportController'
						controllerAs: 'vm'
						templateUrl: '@app/report/fiskaly/fiskaly.view.html'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					integrations: (IntegrationRepository) ->
						return IntegrationRepository.getEntities()
					registers: (RegisterRepository) ->
						query = RegisterRepository.createQuery()
						query.with('entity_attribute_relation')

						return RegisterRepository.getEntities(query)
					shops: (ShopRepository) ->
						return ShopRepository.getEntities()
